class ImageContainerResizer {
  constructor() {
    this.images = document.querySelectorAll('.lc-infobox__image'); // Select all matching images
    this.updateImageContainerHeight = this.updateImageContainerHeight.bind(this); // Bind context
    this.updateImageContainerHeight(); // Initial update
    window.addEventListener("resize", this.updateImageContainerHeight);
  }

  updateImageContainerHeight() {
    this.images.forEach(image => {
      const container = image.closest(".lc-infobox__col--image");
      if (image && container) {
        const imageHeight = image.offsetHeight;
        container.style.height = `${imageHeight}px`;
      }
    });
  }

  unsubscribe() {
    window.removeEventListener("resize", this.updateImageContainerHeight);
  }
}

export default ImageContainerResizer;
